import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ClassesApi from '../generated/api/Classes';

export default (service: Servicelayer) => ({
  ...ClassesApi(service),

  // Add custom calls here

});
